import { Address, AddressType } from "@models/Address";

/** City / state / zip line; omits zip when null or empty (e.g. Hong Kong). */
export const formatAddressLocality = (address: {
  city: string;
  state: { code: string };
  zip?: string | null;
}) => {
  const base = `${address.city}, ${address.state.code}`;
  return address.zip ? `${base} ${address.zip}` : base;
};

export const formatAddress = (address: Address) =>
  `${address.streetAddress1}${
    address.streetAddress2 ? `, ${address.streetAddress2}` : ""
  }, ${formatAddressLocality(address)}`;

/** Custom addresses show `c{id}`; distributors show ABN. */
export const getAddressDisplayId = (address: Address) =>
  address.type === AddressType.Custom
    ? `c${address.id}`
    : (address.abn ?? "---");

/** User-specific attention line, falling back to the address default. */
export const getDisplayAttn = (address: Address) =>
  address.currentUserAttn ?? address.defaultAttn ?? "---";
